import { useMemo } from 'react';

import { lodash } from 'helpers';
import { useTranslation } from 'libs/i18n';
import {
  ContactsSection,
  AdditionalDocumentsSection,
  CompanyStateRegistrationSection,
  CompanyRegistrationAddressSection,
  CompanyResidentialAddressSection,
} from 'modules/client/common/components/sections';
import { CompanyTaxResidencySection } from 'modules/client/legal/components/sections';

import { LegalClientBranchNameSection } from '../sections';

import { LegalClientBranchSectionsProps } from './types';

export const useLegalClientBranchSections = ({
  countries,
  countriesLoading,
}: LegalClientBranchSectionsProps) => {
  const { t } = useTranslation();

  const tabs = useMemo(
    () =>
      lodash.compact([
        {
          label: t('client.legal.legalClientBranch.sections.main'),
          id: 'main',
          content: (
            <>
              <LegalClientBranchNameSection />

              <CompanyStateRegistrationSection
                hideDocuments
                isFirstRegistrationDate={false}
              />

              <CompanyTaxResidencySection
                countries={countries}
                countriesLoading={countriesLoading}
              />
            </>
          ),
          formSectionKeys: [
            'branchName',
            'companyStateRegistration',
            'companyTaxResidences',
          ],
        },
        {
          label: t('client.legal.legalClientBranch.sections.contacts'),
          id: 'contacts',
          content: (
            <>
              <CompanyRegistrationAddressSection
                countries={countries}
                countriesLoading={countriesLoading}
              />

              <CompanyResidentialAddressSection
                countries={countries}
                countriesLoading={countriesLoading}
              />

              <ContactsSection isEditAllowed />
            </>
          ),
          formSectionKeys: [
            'companyRegistrationAddress',
            'companyResidentialAddress',
            'contacts',
          ],
        },
        {
          label: t('client.legal.legalClientHead.sections.documents'),
          id: 'documents',
          content: <AdditionalDocumentsSection />,
          formSectionKeys: ['additionalDocumentsFiles'],
        },
      ]),
    [countries, countriesLoading, t]
  );

  return { tabs };
};
